import { FirebaseService } from "@core/firebase/firebase.service";

//CHECK_THIS: Delete post verify sentry with app component
export const firebaseFactory = (firebaseService:FirebaseService) => () => firebaseService.login()